module.exports = __webpack_public_path__ + "img/icon_armazenamento_digital_repositorio_unico.8a55a83d.svg";